import React, { useEffect, useRef, useState } from 'react';
import { sanitizeRichHtml } from '../../utils/sanitize';
import { useTemplate } from '../../hooks/useTemplate';
import { LoadingMessage } from '../ModalMessage/LoadingMessage';
import WebViewModal from '../WebViewModal/WebViewModal';
import { track } from '../../lib/analytics';
import './TemplateModal.css';

const TemplateModal = ({ templateId, onClose }) => {
    const { template, loading, error, fetchTemplate } = useTemplate();
    const contentRef = useRef(null);
    useEffect(() => {
        if (templateId) {
            fetchTemplate(templateId);
        }
    }, [templateId]);

    // O paywall APARECEU = alguém esbarrou num conteúdo bloqueado. É o topo do funil de
    // conversão. Só mandamos o id do template (qual página de venda), nunca dado de pessoa.
    useEffect(() => {
        if (template) track('paywall_visto', { template_id: templateId });
    }, [template, templateId]);

    useEffect(() => {
        if (template && contentRef.current) {
            // Interceptar cliques em links dentro do HTML do template
            const handleLinkClick = (event) => {
                const target = event.target.closest('a');
                if (target && target.href) {
                    // Verificar se é um link externo
                    const url = new URL(target.href);
                    const currentDomain = window.location.hostname;

                    if (url.hostname !== currentDomain) {
                        // Clicou no checkout (link externo, nova aba) = foi COMPRAR. É o fundo
                        // do funil no que o site controla — a venda em si acontece na Greenn.
                        track('checkout_iniciado', { template_id: templateId });
                        event.preventDefault();
                        window.open(target.href, '_blank');
                    }
                }
            };

            contentRef.current.addEventListener('click', handleLinkClick);
            
            return () => {
                if (contentRef.current) {
                    contentRef.current.removeEventListener('click', handleLinkClick);
                }
            };
        }
    }, [template]);

    if (loading) return <LoadingMessage />;
    if (error) return null;
    if (!template) return null;

    return (
        <div className="template-modal-overlay" onClick={onClose}>
            <div className="template-modal-content" onClick={e => e.stopPropagation()}>
                <button className="template-modal-close" onClick={onClose}>×</button>
                <div
                    ref={contentRef}
                    className="template-modal-html"
                    dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(template.html) }}
                />
            </div>
        </div>
    );
};

export default TemplateModal; 